export default "__VITE_ASSET__CT22uEu3__"